import { StrictMode } from 'react';
import { ThemeProvider } from '@sixui/ui';
import ReactDom from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';

import { AppPreviewProvider } from '~/components/organisms/AppPreview';
import { GoogleTagManager } from '~/components/utils/GoogleTagManager';
import { HotJar } from '~/components/utils/Hotjar';
import { LinkBehavior } from '~/components/utils/Navigation';
import { PersistentColorSchemeProvider } from '~/components/utils/PersistentColorSchemeProvider';
import { ApiProvider } from '~/lib/api';
import { MultiSessionsProvider } from '~/lib/auth';
import { initSentry } from '~/lib/sentry';
import theme from '~/styles/theme.json';
import { router } from './router';

import './i18n/index';
import '@sixui/ui/styles.css';
import './index.css';

initSentry();

ReactDom.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <GoogleTagManager />
      <HotJar />
      <Helmet titleTemplate="%s - Crowdaa" />
      <MultiSessionsProvider>
        <ApiProvider clientId="dashboard">
          <AppPreviewProvider>
            <ThemeProvider
              theme={theme}
              settings={{
                linkAs: LinkBehavior,
              }}
            >
              <PersistentColorSchemeProvider>
                <RouterProvider
                  router={router}
                  future={{
                    v7_startTransition: true,
                  }}
                />
              </PersistentColorSchemeProvider>
            </ThemeProvider>
          </AppPreviewProvider>
        </ApiProvider>
      </MultiSessionsProvider>
    </HelmetProvider>
  </StrictMode>,
);
